export enum AccountType {
    availableMoney = '1', // ! 📚 its not in documentation
    CashOnTable = '0x2', // total amount on table / currently getting play
    CashOnHold = '0x4', // total of amount that is locked by an administrator or pending from a deposit
    CashIncome = '0x8', // amount received by affiliate that will be unlock periodially per week
    CashToken = '0x16', // Satellite token received, money is locked and will be used when the token will be used.
    PointsToUnlock = '0x200', // real counter of points,
}